import { service } from '@/utils/request'
import constv from '@/config/constv'

class admin {
  static getList (params) { return service.get(constv.AUTH_URL + '/admin/admin/getAdminList', { params }) }
  static add (id, params) { return service.post(constv.AUTH_URL + '/admin/admin/addAdmin?id=' + id, params) }
  static edit (id, params) { return service.post(constv.AUTH_URL + '/admin/admin/editAdmin?id=' + id, params) }
  static detail (id) { return service.get(constv.AUTH_URL + '/admin/admin/editAdmin?id=' + id) }
  static delete (params) { return service.post(constv.AUTH_URL + '/admin/admin/delAdmin', params) }
}

export default admin
